import { Alert, Flex, List, Pill, Text, ToggleDetails } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { AssessmentPlanService } from "../services/AssessmentService";
import { AssignmentService } from "../services/AssignmentService";
import AssignmentRubric from "../views/Dashboard/Faculty/Components/AssignmentRubric";
import { Card } from "./Card";
import { sortOutcomes } from "./LearningOutcomes/utils";

const Assignment = ({
  assignment,
  assessment,
  term,
  sectionAssignmentResults,
  // barChartIndex,
}) => {
  const { t } = useTranslation();
  const [assignLoad, setAssignLoad] = useState(false);
  const [frequencyInfoLoad, setFrequencyInfoLoad] = useState(false);
  const [result, setResult] = useState({});
  const [resultCount, setResultCount] = useState(0);
  // const [masteryPoints, setMasteryPoints] = useState(null);
  const [rubricLoaded, setRubricLoaded] = useState(false);
  // const [rubricScale, setRubricScale] = useState(null);
  // const [row, setRows] = useState([]);
  // const [cols, setCols] = useState([]);
  const assignmentType = useMemo(() => {
    return assignment && assignment.name && assignment.name.includes(":")
      ? assignment.name.split(":")[1].trim()
      : t("assessment.externalAssessment");
  }, [assignment]);
  const [assignmentData, setAssignmentData] = useState(null);

  useEffect(() => {
    AssignmentService.getAssignmentResults(assignment.id).then(
      (assignmentResults) => {
        setAssignLoad(false);
        if (!Object.hasOwn(assignment, "goal")) {
          AssessmentPlanService.getAssessmentById(
            assignment.assessment_id
          ).then((assessment) => {
            assignment.goal = assessment.goal.description;
          });
        }
        let assignmentInfo = null;
        sectionAssignmentResults.forEach((assign) => {
          Object.keys(assign).forEach((key) => {
            if (key === assignment.id) {
              assignmentInfo = assign[key];
              assignmentInfo["assignment"] = assignment;
              let outcomesArr = [];

              let index = 0;
              while (
                assignmentInfo["outcome-" + (index + 1).toString()] != undefined
              ) {
                outcomesArr.push(assignmentInfo["outcome-" + index.toString()]);
                index += 1;
              }

              outcomesArr = sortOutcomes(outcomesArr, (lo) => lo.outcome);

              outcomesArr.forEach((outcome, j) => {
                assignmentInfo["outcome-" + j.toString()] = outcome;
              });

              setAssignmentData(assignmentInfo);
              let score_list = [];
              let total_results = 0;
              Object.keys(assignmentResults).forEach((key) => {
                Object.keys(assignmentInfo).forEach((outcome_id) => {
                  if (
                    outcome_id !== "assignment" &&
                    assignmentInfo[outcome_id].outcome.id === key
                  ) {
                    const obj = {};
                    obj["outcome"] = assignmentInfo[outcome_id].outcome;
                    obj["results"] = assignmentResults[key];
                    score_list.push(obj);
                  }
                });
                Object.values(assignmentResults[key]).forEach((val) => {
                  total_results += val;
                });
              });
              score_list = sortOutcomes(score_list, (lo) => lo.outcome);
              setResult(score_list);
              setFrequencyInfoLoad(true);
              setRubricLoaded(true);
              setAssignLoad(true);
              setResultCount(total_results);
            }
          });
          if (!assignmentInfo) {
            setFrequencyInfoLoad(true);
            setRubricLoaded(true);
            setAssignLoad(true);
          }
        });
        if (!assignmentInfo) {
          setFrequencyInfoLoad(true);
          setRubricLoaded(true);
          setAssignLoad(true);
        }
      }
    );
  }, [sectionAssignmentResults, assignment]);

  // const scrubDupes = (arr) => {
  //   let newArr = [];
  //   newArr = [...new Map(arr.map((item) => [item.id, item])).values()];
  //   return newArr;
  // };

  // const populateLos = (vals) => {
  //   if (vals[0] !== {} && vals[0].length > 0) {
  //     let loArr = [];
  //     vals[0].forEach((cslo) => {
  //       let csloId = cslo.cslo_id;
  //       loArr.push(csloId);
  //     });
  //     if (loArr.length > 0) {
  //       LearningOutcomesService.getLearningOutcomesByIds(loArr, true).then(
  //         (clos) => {
  //           setMasteryPoints(
  //             clos[0].rating_scales
  //               ? clos[0].rating_scales[0].mastery_at
  //               : "rating scale information missing"
  //           );
  //           setRubricScale(
  //             clos[0].rating_scales ? clos[0].rating_scales[0] : null
  //           );

  //           setAssignLoad(true);
  //           MasteryLevelService.getMasteryLevels().then((levels) => {
  //             let masteryMap = {};
  //             levels.forEach((level) => {
  //               masteryMap[level.id] = level.level;
  //             });
  //             // buildGrid(clos, masteryMap);
  //           });
  //         }
  //       );
  //     }
  //   } else {
  //     setRubricScale(null);
  //     setRubricLoaded(true);
  //     setAssignLoad(true);
  //   }
  // };

  // const StudentScoreBarChart = (res) => {
  //   useEffect(() => {
  //     let scoreDist = [["terms", "Assessment Scores"]];
  //     let possible = null;
  //     if (res.res && res.res.length > 0) {
  //       possible = res.res[0].possible;
  //     }
  //     for (let i = 0; i < possible + 1; i++) {
  //       scoreDist.push([i.toString(), 0]);
  //     }
  //     Object.keys(res.res).length > 0 &&
  //       res.res.forEach((element) => {
  //         scoreDist[element.score + 1][1] = scoreDist[element.score + 1][1] + 1;
  //       });
  //     scoreDist = scoreDist.filter((dist) => dist[1] !== 0);
  //     c3.generate({
  //       bindto: `#scores-per-students_${barChartIndex}`,
  //       size: {
  //         height: 190,
  //       },
  //       data: {
  //         x: "terms",
  //         columns: scoreDist,
  //         type: "bar",
  //       },
  //       bar: {
  //         // width: 15, // this makes bar width 100px
  //       },
  //       axis: {
  //         x: {
  //           type: "category",
  //           label: {
  //             text: term,
  //             position: "outer-center",
  //           },
  //           tick: {
  //             // rotate: 75,
  //             multiline: false,
  //           },
  //         },
  //         y: {
  //           label: {
  //             text: t("assignment.scoreFrequency"),
  //             position: "outer-middle",
  //           },
  //         },
  //       },
  //     });
  //   }, []);
  //   if (res.res && res.res.length > 0) {
  //     return <div id={`scores-per-students_${barChartIndex}`} />;
  //   } else {
  //     return <Alert>No scores available for this assignment</Alert>;
  //   }
  // };

  // const buildGrid = (los, masteryMap) => {
  //   los = scrubDupes(los);

  //   let colObj = [
  //     {
  //       id: "criteria",
  //       name: "Criteria",
  //       key: "criteria",
  //       width: 150,
  //     },
  //   ];
  //   let rowObj = [];
  //   los.forEach((lo, index) => {
  //     let obj = {
  //       criteria: (
  //         <Tooltip
  //           color="primary-inverse"
  //           renderTip={<div style={{ width: 250 }}>{lo.statement}</div>}
  //           placement="top"
  //           offsetX="5px"
  //         >
  //           <Text size="small">
  //             <TruncateText maxLines={5}>{lo.statement}</TruncateText>
  //           </Text>
  //         </Tooltip>
  //       ),
  //     };
  //     rowObj.push(obj);
  //     lo.rating_scales[0].rating_levels.forEach((rating) => {
  //       let new_object = {};
  //       new_object.name = (
  //         <Tooltip
  //           color="primary-inverse"
  //           renderTip={
  //             <div style={{ width: 200 }}>
  //               {rating.points +
  //                 ": " +
  //                 masteryMap[rating.insights_rating_level.mastery_level_id]}
  //             </div>
  //           }
  //           on={["hover", "focus"]}
  //           placement="top"
  //           offsetX="5px"
  //         >
  //           {rating.points +
  //             ": " +
  //             masteryMap[rating.insights_rating_level.mastery_level_id]}
  //         </Tooltip>
  //       );
  //       new_object.key = rating.points.toString();
  //       if (index === 0) {
  //         colObj.push(new_object);
  //       }
  //       rowObj[index][rating.points.toString()] = (
  //         <Tooltip
  //           color="primary-inverse"
  //           on={["hover", "focus"]}
  //           renderTip={<div style={{ width: 250 }}>{rating.description}</div>}
  //           placement="top"
  //           offsetX="5px"
  //         >
  //           <Text size="small">
  //             <TruncateText maxLines={5}>{rating.description}</TruncateText>
  //           </Text>
  //         </Tooltip>
  //       );
  //     });
  //   });
  //   setRows(rowObj);
  //   setCols(colObj);
  //   setRubricLoaded(true);
  // };

  return !assignLoad ? (
    <Skeleton count={1} style={{ height: 260, borderRadius: 5 }} />
  ) : (
    <Card style={{ height: "auto", minHeight: 230 }}>
      <Flex wrap="wrap" justifyItems="space-between" alignItems="start">
        <Flex.Item size="50%">
          <Text as="div" weight="bold">
            {t("assessment.assignmentType")}:{" "}
            {assignmentType ? assignmentType : ""}
          </Text>
        </Flex.Item>
        <Flex.Item textAlign="end">
          <Text as="div">
            <Pill>{term}</Pill>
          </Text>
        </Flex.Item>
        <Flex.Item size="100%">
          {assignment.goal ? (
            <Text as="div">
              <Text as="span" weight="bold">
                {t("assignment.assignmentPurpose")}{" "}
              </Text>
              {assignment.goal}
            </Text>
          ) : (
            <Alert>{t("assignment.noGoalAssociated")}</Alert>
          )}
        </Flex.Item>
        <Flex.Item>
          <Flex margin="small 0">
            <Flex.Item>
              {Object.keys(result).length > 0 ? (
                <Pill color="success">
                  {resultCount} {t("assignment.resultsCollected")}
                </Pill>
              ) : (
                <Pill>{t("assignment.noResultsCollected")}</Pill>
              )}
            </Flex.Item>
          </Flex>
        </Flex.Item>
        <Flex.Item width="100%">
          <ToggleDetails size="small" summary={t("assignment.rubricDetails")}>
            {!rubricLoaded ? (
              <Skeleton count={1} style={{ height: 80, borderRadius: 5 }} />
            ) : assignmentData ? (
              <div>
                <AssignmentRubric
                  assignmentData={assignmentData}
                  assessment={assessment}
                />
              </div>
            ) : (
              <Alert variant="info">{t("assignment.noResults")}</Alert>
            )}
          </ToggleDetails>
        </Flex.Item>
        <Flex.Item width="100%">
          <ToggleDetails
            size="small"
            summary={t("assignment.masteryBreakdown")}
          >
            {!frequencyInfoLoad ? (
              <Skeleton
                count={1}
                style={{
                  height: 150,
                  borderRadius: 5,
                  width: 600,
                  marginLeft: 25,
                }}
              />
            ) : (
              <List isUnstyled>
                {Object.keys(result).length > 0 ? (
                  result.map((result_entry, key) => (
                    // make lo names shorter with ellipses and display on hover
                    <List.Item key={key} margin="small 0">
                      <Text as="p" size="small">
                        {result_entry["outcome"].name}
                      </Text>
                      <Flex alignItems="start" direction="column">
                        {result_entry &&
                          Object.keys(result_entry["results"]).map(
                            (scoreKey, key2) => (
                              <Flex.Item key={key2}>
                                <Text size="small">
                                  <Text size="small" weight="bold">
                                    {t("assignment.score")}:
                                  </Text>{" "}
                                  {scoreKey},{" "}
                                  <Text size="small" weight="bold">
                                    {t("assignment.studentCount")}:
                                  </Text>{" "}
                                  {result_entry["results"][scoreKey]}
                                </Text>
                              </Flex.Item>
                            )
                          )}
                      </Flex>
                    </List.Item>
                  ))
                ) : (
                  <List.Item>
                    <Alert>{t("assignment.noResults")}</Alert>
                  </List.Item>
                )}
              </List>
            )}
          </ToggleDetails>
        </Flex.Item>
        {/* Will be added at a later time when Redshift endpoints are available */}
        {/* <Flex.Item width="100%">
          <ToggleDetails size="small">
            <SunburstChart
              data={sunburstData}
              subject={"ACCT"}
              height={175}
              width={175}
              centerRadius={0.1}
              excludeRoot={true}
              labelOrientation="angular"
              tooltipContent={(d, node) => `Size: <i>${node.value}</i>`}
            />
          </ToggleDetails>
        </Flex.Item> */}
      </Flex>
    </Card>
  );
};

export default Assignment;
